import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogContent, Tooltip} from "@material-ui/core";

import {Col, Row} from "antd";
import Button from "@material-ui/core/Button";
import React, {useEffect, useState} from "react";

import useStyles from "./styles";
import Typography from "@material-ui/core/Typography";
import UserDetailsBaseSection from "./UserDetailsBaseSection";
import UserDetailsRightsSection from "./UserDetailsRightsSection";
import * as Yup from "yup";
import {useFormik} from "formik";
import useRights from "../../../shared/functions/useRights";
import PopupState, {bindPopover, bindTrigger} from "material-ui-popup-state";
import DeleteIcon from "@material-ui/icons/Delete";
import Popover from "@material-ui/core/Popover";
import {Alert} from "@material-ui/lab";
import {isEmpty} from "lodash";


export default function UserForm({open, onClose, onSubmit, onDelete, user, title, loading = false, deleteOpt = false}) {
    const classes = useStyles();
    const {RIGHTS} = useRights()

            if (!isEmpty(user)){
                deleteOpt = true
                console.log(user,title)
            }




    const [data, setData] = useState(user ?? {
        photoURL: "",
        displayName: '',
        email: '',
        disabled: false,
        rights: RIGHTS
    })



    const schema = Yup.object().shape({
        displayName: Yup.string().required("Champs doit etre remplis"),
        email: Yup.string().email("Respecter le format email").required("Champs doit etre remplis"),
        disabled: Yup.bool().required("Champs doit etre remplis")
    })

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            photoURL: user?.photoURL ?? "",
            displayName: user?.displayName ?? '',
            email: user?.email ?? '',
            disabled: user?.disabled ?? false,
            password: '',
        },
        validationSchema: schema,
        onSubmit: values => {
            setData({...data, ...values})
            onSubmit && onSubmit({...data, ...values})
        }
    })

    const handleClose = () => onClose && onClose();

    const handleRightsChange = (change) => {
        setData({...data, rights: {...change}});
    }

    const handleDeletion = () => onDelete && onDelete()

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth={"md"}>
            <AppBar className={classes.appBar}>
                <Toolbar>

                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon/>
                    </IconButton>

                    <div hidden={!deleteOpt}>
                        <PopupState variant="popover" popupId="demo-popup-popover">
                            {(popupState) => (
                                <div>
                                    <Tooltip title={'Supprimer'} {...bindTrigger(popupState)}>
                                        <IconButton edge="end" color="inherit">
                                            <DeleteIcon/>
                                        </IconButton>
                                    </Tooltip>

                                    <Popover
                                        {...bindPopover(popupState)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <>
                                            <Row>
                                                <Alert severity="error">Attention - Etes-vous sûr de vouloir
                                                    supprimer </Alert>
                                            </Row>
                                            <Row justify={"end"}>
                                                <Button color={"secondary"} onClick={handleDeletion}>
                                                    Oui - je suis sûr
                                                </Button>
                                                <Button color={"primary"} onClick={() => popupState.close()}>
                                                    Non
                                                </Button>
                                            </Row>
                                        </>
                                    </Popover>
                                </div>
                            )}
                        </PopupState>
                    </div>

                    <Typography variant="h6" className={classes.title}>
                        {title}
                    </Typography>

                    <Button autoFocus color="inherit" onClick={formik.handleSubmit}>
                        Valider
                    </Button>


                </Toolbar>
            </AppBar>
            <DialogContent>
                <Row justify={"center"}>
                    <Row>
                        <Col className={classes.card}>
                            <UserDetailsBaseSection
                                user={data}
                                formik={formik}
                                loading={loading}
                            />
                        </Col>
                        <Col className={classes.card}>
                            <UserDetailsRightsSection
                                rights={data.rights}
                                onChange={handleRightsChange}
                                loading={loading}
                            />
                        </Col>
                    </Row>
                </Row>
            </DialogContent>
        </Dialog>
    )
}